import { cva, type VariantProps } from "class-variance-authority";
import { type FC, type HTMLAttributes, type Ref } from "react";
import { cn } from "../lib/utils";
import { trackingAttrs } from "../utils";

const spinnerVariants = cva(
	"inline-block rounded-full border-2 border-current border-r-transparent animate-spin",
	{
		variants: {
			size: {
				sm: "h-3 w-3",
				md: "h-4 w-4",
				lg: "h-5 w-5",
			},
		},
		defaultVariants: {
			size: "sm",
		},
	},
);

export type SpinnerProps = HTMLAttributes<HTMLSpanElement> &
	VariantProps<typeof spinnerVariants> & {
		trackingId?: string;
		ref?: Ref<HTMLSpanElement>;
	};

export const Spinner: FC<SpinnerProps> = ({ size, trackingId, className, ref, ...rest }) => (
	<span
		ref={ref}
		aria-hidden
		className={cn(spinnerVariants({ size }), className)}
		{...trackingAttrs(trackingId)}
		{...rest}
	/>
);
Spinner.displayName = "Spinner";
